module.exports = __webpack_public_path__ + "img/caret-right.8bffc888.svg";